import type { ReactElement } from 'react';

import styled, { css } from 'styled-components';

import { LayoutToggle } from '../LayoutToggle';
import { TotalNumberOfProducts } from '../TotalNumberOfProducts';
import { media } from '~/components/shared/core/styles';

const S = {
  SearchMetadata: styled.div`
    ${({ theme }) => css`
      display: flex;
      gap: ${theme.spacing.x.sm};
      align-items: center;
      justify-content: space-between;
      color: ${theme.colors.content.secondary};
      background-color: ${theme.colors.background.base};
      overflow: hidden;
      padding-right: ${theme.padding.sm};
    `}
  `,

  TotalNumberOfProducts: styled(TotalNumberOfProducts)`
    ${({ theme }) => css`
      padding-bottom: ${theme.padding.none} !important;
      margin: 0;
    `}
  `,

  LayoutToggleButton: styled(LayoutToggle)`
    ${({ theme }) => css`
      display: flex;
      gap: ${theme.spacing.x.sm};

      @media ${media(theme).greaterThan('sm')} {
        gap: ${theme.spacing.x['2xs']};
      }

      button {
        display: flex;
        align-items: center;
        margin: 0;
        height: 26px;
      }
    `}
  `,
};

export const SearchMetadataBar = (): ReactElement => (
  <S.SearchMetadata>
    <S.TotalNumberOfProducts />
    <S.LayoutToggleButton />
  </S.SearchMetadata>
);
